/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSplunk extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSplunk");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSplunk.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSplunk>): ServiceAccountNativeDetailsForSplunk {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSplunk(), model);
        ServiceAccountNativeDetailsForSplunk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSplunk>): ServiceAccountNativeDetailsForSplunk {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSplunk.newInstance(<ServiceAccountNativeDetailsForSplunk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSplunk) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSplunk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSplunk): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSplunk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
